import { createPortal } from "react-dom";
import clsx from "../../../../modules/helpers/clsx";
import useWindowSize from "../../../../modules/helpers/windowSize";
import useMountTransition from "../../../../modules/player/hooks/useMountTransition";
import { FocusContext, useFocusable } from "../../../../modules/spatialNavigation";
import IconComponent from "../../icon/IconComponent";
import IconButton from "../../iconButton/IconButtonComponent";
import FocusableButton from "../../focusableButton/FocusableButton";
import * as styles from "./styles.module.scss";

interface IProps {
  open: boolean;
  title?: string;
  description?: string;
  confirmTitle?: string;
  cancelTitle?: string;
  onClose: () => void;
  onConfirm: () => void;
  onCancel?: () => void;
}

const ConfirmationDialog = (props: IProps) => {
  const { ref, focusKey } = useFocusable({
    focusBoundaryDirections: ["left", "right", "up", "down"],
    isFocusBoundary: true,
  });
  const { shouldFadeIn, shouldMount } = useMountTransition(props.open);
  const [width, height] = useWindowSize();

  if (!shouldMount) {
    return null;
  }

  const dialogContent = (
    <FocusContext.Provider value={focusKey}>
      <div
        className={clsx({
          [styles.dialog]: true,
          [styles.fade]: !shouldFadeIn,
        })}
        style={{ width, height }}
      >
        <div className={styles.dialogContainer} ref={ref}>
          <h2 className={styles.title}>{props.title}</h2>
          {props.description && (
            <div className={styles.content}>
              <p className={styles.description}>{props.description}</p>
            </div>
          )}
          <div className={styles.footer}>
            <FocusableButton
              focusKey="cancelDialogButton"
              label={props.cancelTitle || "بستن"}
              onClick={props.onCancel || props.onClose}
              fullWidth
              isCentered
            />
            <FocusableButton
              focusKey="confirmDialogButton"
              label={props.confirmTitle || "تایید"}
              onClick={props.onConfirm}
              fullWidth
              isCentered
            />
          </div>
        </div>
      </div>
    </FocusContext.Provider>
  );

  return createPortal(dialogContent, document.body);
};

export default ConfirmationDialog;
